/** @jsxImportSource @emotion/react */

'use client';
import { Box, type SxProps, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { campaignManagerTheme } from '@campaign-manager/theme';

import * as styles from './styles';

interface Props {
  children: ReactNode;

  compact?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  color?: string;
  sx?: SxProps;
  className?: string;
}

export default function Prose({
  children,
  compact,
  size = 'md',
  color = 'inherit',
  sx,
  className,
}: Props) {
  return (
    <Box
      component="div"
      css={[styles.prose, ...(compact ? [styles.proseCompact] : [])]}
      className={className}
      sx={{
        color: color,
        fontSize: campaignManagerTheme.fontSize[size],
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export function ProseCompact({ children, ...rest }: Props) {
  return (
    <Prose
      compact
      {...rest}
    >
      {children}
    </Prose>
  );
}
